import React, { useState, useCallback } from 'react'

import UserNotice from '../components/UserNotice';

export const useUserNotice = (onClose, forceDecision) => {
  const [isVisible, setIsVisible] = useState(false);
  const [propsForChild, setPropsForChild] = useState();

  const show = (props) => { setPropsForChild(props); setIsVisible(true); window.scrollTo(0, 0); }
  const hide = (success) => { setIsVisible(false); if (onClose) onClose(success);}

  const RenderUserNotice = useCallback(
    ({ children }) => (
      <>
        {isVisible && <UserNotice closeNotice={hide} asDialog={forceDecision}>{React.cloneElement(children, { ...propsForChild, closeNotice: hide })}</UserNotice>}
      </>
    ),
    [propsForChild, isVisible]
  );

  return {
    show,
    hide,
    RenderUserNotice,
  }
}